<template>
    <v-container>
        <v-form v-if="tpl == 'contact'"
            ref="formCreate"
            >
            <v-row>
                <v-col
                        cols="12"
                >
                    <p class="font-weight-bold mb-6 text-center display-2">Contact</p>
                    <hr>
                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        class="text-center"
                >
                    <v-text-field
                            v-model="form.name"
                            prepend-icon="mdi-account"
                            maxlength="200"
                            counter="200"
                            :rules="nameRules"
                            label="Name"
                            required
                    ></v-text-field>
                    <v-text-field
                            v-model="form.email"
                            prepend-icon="mdi-mail"
                            maxlength="200"
                            :rules="emailRules"
                            label="Email"
                            required
                    ></v-text-field>
                    <v-text-field
                            v-model="form.subject"
                            prepend-icon="mdi-check"
                            maxlength="200"
                            counter="200"
                            :rules="subjectRules"
                            label="Subject"
                            required
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                    <v-textarea
                            outlined
                            label="Text"
                            :rules="textRules"
                            v-model="form.text"
                            counter="500"
                            maxlength="500"
                            required
                    ></v-textarea>
                    <v-btn
                            :loading="loading.general"
                            color="success"
                            @click="sendMsg"
                    >
                        Send
                        <v-icon right>
                            mdi-send
                        </v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
        <v-row v-else>
            <v-row cols="12">
                <p>Thanks. Soon we will return your contact</p>
            </v-row>
        </v-row>
    </v-container>
</template>
<script>
    export default {
        props: {
            appUrl: { type: String },
            cdnUrl: { type: String },
        },
        metaInfo () {
            return {
                title: 'PPS Healthcare – Contact',
                meta: [
                    {description: 'PPS Healthcare – Contact'},
                    {keywords: 'PPS Healthcare – Contact'}
                ]
            }
        },
        data () {
            return {
                emailRules: [
                    v => !!v || 'E-mail is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid',
                ],
                nameRules: [
                    v => !!v || 'Name is required',
                    v => v.length >= 2 || 'Min 3 characters',
                ],
                subjectRules: [
                    v => !!v || 'Subject is required',
                    v => v.length >= 3 || 'Min 5 characters',
                ],
                textRules: [
                    v => !!v || 'Text is required',
                    v => v.length >= 10 || 'Min 10 characters',
                ],
                form:{
                  name:"",
                  email:"",
                  subject:"",
                  text:""
                },
                msg:[],
                erro:false,
                loading:{
                    general:false,
                },
                tpl:'contact'
            }
        },
        methods:{
            sendMsg(){
                if (this.$refs.formCreate.validate()) {
                    //this.loading.general = true;
                    var arr = JSON.stringify(this.form);
                    this.$http.post(this.appUrl+"/store/contact",arr).then(response => {
                        this.loading.general = false;
                        if(response.data.erro){
                            this.erro = true;
                            this.msg = response.data.msg;
                        }
                        this.tpl = "sent";
                    });
                }
            }

        }
    }
</script>